import { render, staticRenderFns } from "./VerifiedPriceBadge.vue?vue&type=template&id=d0432bae&"
import script from "./VerifiedPriceBadge.vue?vue&type=script&lang=js&"
export * from "./VerifiedPriceBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports